import { selectMatchStatusId } from 'features/match/matchSlice';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { MatchStatus } from '../../enums/matchStatus';

const MatchPeriod: React.FC = () => {
  const matchStatusId = useSelector(selectMatchStatusId);

  let id: string;

  switch (matchStatusId) {
    case MatchStatus.NOT_STARTED:
      id = 'states.notStarted';
      break;

    case MatchStatus.FIRST_HALF:
      id = 'states.firstHalf';
      break;

    case MatchStatus.HALF_TIME:
      id = 'states.pause';
      break;

    case MatchStatus.SECOND_HALF:
      id = 'states.secondHalf';
      break;

    case MatchStatus.PAUSE_BEFORE_EXTRA_TIME:
      id = 'states.pauseBeforeExtraTime';
      break;

    case MatchStatus.FIRST_HALF_EXTRA_TIME:
      id = 'states.firstHalfExtraTime';
      break;

    case MatchStatus.HALF_TIME_EXTRA_TIME:
      id = 'states.halfTimeExtraTime';
      break;

    case MatchStatus.SECOND_HALF_EXTRA_TIME:
      id = 'states.secondHalfExtraTime';
      break;

    case MatchStatus.PENALTIES:
      id = 'states.penalties';
      break;

    case MatchStatus.PLAYED:
      id = 'states.ended';
      break;

    default:
      id = 'states.notStarted';
  }
  return <FormattedMessage id={id} />;
};

export default MatchPeriod;
